import { createAction }  from 'redux-actions';
import { ADD_TO_CART, REMOVE_CART_ITEM, TOGGLE_CHECKOUT, PURCHASE_COMPLETED} from '../types';


export const addToCart = createAction(ADD_TO_CART, values => values )
export const removeCartItem = createAction(REMOVE_CART_ITEM, item => item)
export const toggleCheckout = createAction(TOGGLE_CHECKOUT)
export const purchaseCompleted = createAction(PURCHASE_COMPLETED)